export const messages = {
  automations: {
    id: 'admin/promotions.form.budget.editor.automations',
  },
  title: {
    id: 'admin/promotions.form.budget.editor.notification.title',
  },
  description: {
    id: 'admin/promotions.form.budget.editor.notification.description',
  },
  checkboxAria: {
    id: 'admin/promotions.form.budget.editor.notification.checkbox.aria',
  },
  notifyAt: {
    id: 'admin/promotions.form.budget.editor.notification.notify-at',
  },
  emailLabel: {
    id: 'admin/promotions.form.budget.editor.notification.email-label',
  },
  emailHelp: {
    id: 'admin/promotions.form.budget.editor.notification.email-help',
  },
  emailInvalid: {
    id: 'admin/promotions.form.budget.editor.notification.email-invalid',
  },
  emailInvalidMultiple: {
    id: 'admin/promotions.form.budget.editor.notification.email-invalid-multiple',
  },
}
